/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const cdc = {
  reconsent: {
    dialog: {
      title: 'Finalización del perfil',
      description: 'De todos modos, necesitamos su consentimiento para lo siguiente',
    },
  },
};
